export default __webpack_public_path__ + "static/matilda-banner-mobile-f40f57931fdcc982c8c1022c6f424b38.webp";